import { PDFDocument } from "@cantoo/pdf-lib";

/**
 * Merges multiple PDF byte arrays into a single PDF document.
 * Pages are appended in order.
 *
 * @param pdfByteArrays - Array of PDF files as Uint8Array or ArrayBuffer
 * @returns Merged PDF as Uint8Array
 */
export const mergePdfs = async (
  pdfByteArrays: (Uint8Array | ArrayBuffer)[],
): Promise<Uint8Array> => {
  const mergedDoc = await PDFDocument.create();

  for (const pdfBytes of pdfByteArrays) {
    const donor = await PDFDocument.load(pdfBytes);
    const pages = await mergedDoc.copyPages(donor, donor.getPageIndices());

    for (const page of pages) {
      mergedDoc.addPage(page);
    }
  }

  return mergedDoc.save();
};
